
import {get_Terrassor_INTERFACE} from "../../../../interface.js";

/* @ngInject */
export class SchemaEpureController {
    /* @ngInject */
    constructor (ApiConst, ApiSimu, ApiExo, $scope, $sce, $compile, $element, $location, $anchorScroll) {
      this.ApiConst = ApiConst
      this.ApiSimu = ApiSimu
      this.ApiExo = ApiExo

      this.svgEpure = null

      this.$sce = $sce
      this.$scope = $scope
      this.$compile = $compile
      this.$element = $element
      this.$location = $location
      this.$anchorScroll = $anchorScroll

      this.onSvgContentChange = this.onSvgContentChange.bind(this)
      $scope.$watch('SchemaEpureController.svgcontent', this.onSvgContentChange)
    }

    $onInit() {

      console.log('SchemaEpureController : init')

      // L'obtention du code svg est réalisée dans SimulatorController, car il y est plus facile de traiter l'aspect asynchrone avec INTERFACE

    }

     // variable bindée : svgcontent <=>  SimulatorController.svgEpure
     onSvgContentChange() {

        // remplissage "à la mano" du container par le SVG (le svg  n'est pas connu au moment du render de l'appli, et il contient des directives ng qui doivent être évaluées)

        // l'element occurence de ce composant (schema-epure)
        var elt2 = this.$element[0]
        // au descent à son premier child
        elt2 = elt2.querySelector('#schema-epure-container')
        // on remplit ce child par un méthode jQuery
        $(elt2).html(this.svgcontent)
        // évaluer le contenu qui contient des drectives ng-click, etc ...
        var fn = this.$compile(elt2)
        // on rattache cette partie évaluée (donc de l'angular) au scope courant
        fn(this.$scope)
    }


clickTest() {
  alert('!!!!!!')
}
    
    // réaction aux actions de type ng-click="SchemaEpureController.clickMouvement('M02') dans le template

    clickMouvement(codeMvt) {

      var doScroll = true
      this.parentSimulator.setCurrentMouvementByCode(codeMvt, doScroll)
      //this.$anchorScroll('panelmouvement')
      //smoothScrollTo('panelmouvement')


      var idPanel = 'panelmouvement'
      this.parentSimulator.$timeout(() => {this.parentSimulator.$scope.$broadcast('OPENPANEL', { id: idPanel })}, 500)
      }

    // réction au ng-click="SchemaEpureController.clickCubature('DPO1') 

    clickCubature(codeCub) {
      var doScroll = true
      this.parentSimulator.setCurrentCubatureByCode(codeCub, doScroll)
      //this.$anchorScroll('panelcubature')
      //smoothScrollTo('panelcubature')
    }


    clickInstallation() {

      if(this.parentSimulator.hasInstallation)
          smoothScrollTo('panelinstallation')
    }


    isCurrentMouvement(code) {
      return this.parentSimulator.isCurrentMouvement(code)
    }

        isCurrentCubature(code) {
      return this.parentSimulator.isCurrentCubature(code)
    }

    isMouvementValid(code)   {
      var valid =  this.parentSimulator.isMouvementValid(code)
      return valid
    }
    
    isInstallationValid() {
      return this.parentSimulator.installationValid
    }

}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/schema-epure/schema-epure.controller.js